var _path, _rect, _rect2, _rect3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCgmBarChartItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 85,
    viewBox: "0 0 59 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.566406 4.0459C0.566406 1.83676 2.35727 0.0458984 4.56641 0.0458984H54.6734C56.8825 0.0458984 58.6734 1.83676 58.6734 4.0459V9.27243H0.566406V4.0459Z",
    fill: "#CE7A35"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.566406,
    y: 10.2656,
    width: 58.107,
    height: 20.0813,
    fill: "#DDA73B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.566406,
    y: 31.3418,
    width: 58.107,
    height: 46.6754,
    fill: "#53A15B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 58.107,
    height: 2.17095,
    transform: "matrix(1 0 0 -1 0.566406 81.1816)",
    fill: "#BA282E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.566406 82.1767C0.566406 83.3757 1.53837 84.3477 2.73736 84.3477H56.5024C57.7014 84.3477 58.6734 83.3757 58.6734 82.1767H0.566406Z",
    fill: "#742F32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgmBarChartItem);
export default __webpack_public_path__ + "static/media/cgmBarChartItem.12799a71d46d4e20392948436fb9368f.svg";
export { ForwardRef as ReactComponent };